import { render, staticRenderFns } from "./cv.vue?vue&type=template&id=0ebdfa01&scoped=true"
import script from "./cv.vue?vue&type=script&lang=ts"
export * from "./cv.vue?vue&type=script&lang=ts"
import style0 from "./cv.vue?vue&type=style&index=0&id=0ebdfa01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebdfa01",
  null
  
)

export default component.exports